module.exports = __webpack_public_path__ + "img/regulations.e540223f.jpg";